export class StrapiModel {
    id: number;
    createdAt: Date;
    publishedAt: Date;
    updatedAt: Date;
}